<template>
  <div>
    <b-modal id="withdraw" ref="modal" title="Withdraw $PXL" @ok="handleOk" ok-title="Withdraw">
      <p>
        Put in a request to withdraw your $PXL here. We batch withdrawals once every 24 hours
        currently in order to keep gas fees at a minimum.
      </p>
      <p>You can only withdraw to the address associated with your Pixel Profile.</p>
      <form ref="form" @sumbit.prevent="onSubmit" @submit.stop.prevent="handleSubmit">
        <b-form-group label="Amount" label-for="amount-input" invalid-feedback="Amount is required">
          <b-form-input
            id="amount-input"
            v-model="amount"
            :state="amountState"
            required
            type="number"
          ></b-form-input>
        </b-form-group>
      </form>
    </b-modal>
  </div>
</template>

<script>
import axios from 'axios'

import { convertToMutez } from '../../util'
import { handleGlobalError } from '../../util'

export default {
  data() {
    return {
      amount: '',
      amountState: null,
    }
  },
  computed: {
    pxlBalance() {
      return this.$store.getters.pxlBalance
    },
  },
  methods: {
    checkFormValidity() {
      const valid = this.$refs.form.checkValidity()
      this.amountState = valid
      return valid
    },
    handleOk(bvModalEvt) {
      // Prevent modal from closing
      bvModalEvt.preventDefault()
      this.onSubmit()
    },
    async handleSubmit() {
      // Exit when the form isn't valid
      if (!this.checkFormValidity()) {
        return
      }
      await this.onSubmit()
    },
    async onSubmit() {
      const amount = convertToMutez(this.amount)
      const { v4: uuidv4 } = require('uuid')
      this.loading = true
      const data = {
        amount,
        id: uuidv4(),
      }
      try {
        this.successToast()
        // Hide the modal manually
        this.$nextTick(() => {
          this.$bvModal.hide('withdraw')
        })
        this.$store.commit('updatePxlBalance', {
          available: this.pxlBalance.available - amount,
          total: this.pxlBalance.total,
          hold: this.pxlBalance.hold + amount,
          pending_withdrawals: [
            {
              id: data.id,
              amount: this.pxlBalance.hold + amount,
              createdAt: new Date(),
            },
          ],
        })
        await axios.post(`${process.env.VUE_APP_PXL_API}/cash-out`, data)
        this.loading = false
      } catch (error) {
        this.$store.commit('updatePxlBalance', {
          available: this.pxlBalance.available + amount,
          total: this.pxlBalance.total,
          hold: this.pxlBalance.hold - amount,
          pending_withdrawals: [], // TODO this should only remove the pending_withdrawal we just added
        })
        console.error('error trying to withdraw $PXL', error)
        handleGlobalError(this, error, 'withdraw $PXL')
      }
    },
    successToast() {
      this.$bvToast.toast(
        'Success! Please wait up to 2 hours for the PXL to show in your wallet.',
        {
          title: 'Withdraw Success!',
          variant: 'success',
          solid: true,
          toaster: 'b-toaster-top-center',
        }
      )
    },
  },
}
</script>
